import { Controller } from "stimulus"
import { dispatchEvent } from "@rails/activestorage"
import filesize from "../../vendor/file-size"
import { fragment, renderTemplate, randomString } from "../../utils"
import Uploader from "./uploader"

function filePreview(file, template) {
  file.uuid = randomString()

  const reader = new FileReader()
  reader.onerror = () => console.log(reader.error)

  function renderPreview() {
    const props = {
      name: file.name,
      id: file.uuid,
      blobId: "{{blobId}}",
      size: filesize(file.size).human('si'),
      url: reader.result,
      is_pdf: file.type == "application/pdf",
      is_image: /^image\//.test(file.type),
      is_audio: /^audio\//.test(file.type),
      is_video: /^video\//.test(file.type)
    }
    const h = renderTemplate(template.innerHTML, props)
    return fragment(h.trim()).firstElementChild
  }

  return {
    element: null,
    load(cb) {
      reader.onload = () => {
        this.element = renderPreview()
        cb(this.element)
      }
      reader.readAsDataURL(file)
    },
    update(data) {
      this.element.innerHTML = Object.entries(data).reduce(
        (acc, [ key, val ]) => {
          return acc
            .replace(`{{${key}}}`, val)
            .replace(encodeURIComponent(`{{${key}}}`), val)
        },
        this.element.innerHTML
      )
    }
  }
}

export default class extends Controller {
  static targets = [ "container", "zone", "field", "template" ]

  drop(e) {
    e.preventDefault()
    if (e.dataTransfer.items) {
      this.#handleItems(e.dataTransfer.items)
    } else {
      this.#handleFiles(e.dataTransfer.files)
    }
  }

  addFile(e) {
    this.#handleFiles(e.target.files)
    e.target.value = null
  }

  #handleItems(items) {
    for (const item of items) {
      if (item.kind == "file") {
        this.#loadFile(item.getAsFile())
      }
    }
  }

  #handleFiles(files) {
    Array.prototype.slice.call(files).forEach(file => this.#loadFile(file))
  }

  highlight() {
    // e.preventDefault()
    this.zoneTarget.classList.add("dropzone--over")
  }

  lowlight() {
    this.zoneTarget.classList.remove("dropzone--over")
  }

  dragOver(e) {
    e.preventDefault()
  }

  #loadFile(f) {
    const preview = filePreview(f, this.templateTarget)
    preview.load(element => {
      this.containerTarget.append(element)
    })
    this.#upload(f, (error, blob) => {
      preview.update({ blobId: blob.id })
      // make this this runs on next tick _after_ the browser committed the previews update
      setTimeout(() => {
        if (error) {
          dispatchEvent(preview.element, "direct-upload:error", { error })
        }
        dispatchEvent(preview.element, "direct-upload:end", { file: f, id: f.uuid })
      }, 1)
    })
  }

  #upload(f, cb) {
    const uploader = new Uploader(this.fieldTarget, f, this.fieldTarget.dataset.directUploadUrl)
    uploader.uploadNow(cb)
  }
}
